<app-tenant-config-proxy [configPath]="'connectionChangeRequest.isActive'" [redirectOnDeactivated]="true">
  <div class="page-container">
    <h1>Hausanschluss-Bestellstrecke</h1>
    <p>Wählen Sie bitte den Vorgang, den Sie beantragen möchten, und die dazugehörige Sparte aus</p>
    <form [formGroup]="orderRequestForm">
      <form-row>
        <mat-form-field fxFlex appearance="outline">
          <mat-label>Sparte</mat-label>
          <mat-select [formControl]="orderRequestForm.controls.area">
            <mat-option *ngFor="let option of getAreaOptions(options$ | async)" [value]="option">
              {{ AreaDisplayName[option] }}
            </mat-option>
            <mat-option *ngIf="!getAreaOptions(options$ | async)?.length" [value]="null" [disabled]="true">
              Keine Option verfügbar
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!orderRequestForm.controls.area.valid && orderRequestForm.controls.area.touched">
            Bitte wählen Sie eine Sparte aus
          </mat-error>
        </mat-form-field>
      </form-row>
      <form-row>
        <mat-form-field fxFlex appearance="outline">
          <mat-label>Art des Vorgangs</mat-label>
          <mat-select [formControl]="orderRequestForm.controls.type">
            <mat-option *ngFor="let option of currentRequestOptions$ | async" [value]="option">
              {{ ConnectionChangeRequestTypeDisplayValues[option]?.name }}
            </mat-option>
            <mat-option *ngIf="!(currentRequestOptions$ | async)?.length" [value]="null" [disabled]="true">
              Keine Option verfügbar
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!orderRequestForm.controls.type.valid && orderRequestForm.controls.type.touched">
            Bitte wählen Sie eine Vorgangsart aus
          </mat-error>
        </mat-form-field>
      </form-row>
      <p>Beim Klick auf "Weiter" werden Sie zum Antragsprozess Ihrer gewählten Anschlussart weitergeleitet</p>
      <button mat-raised-button color="primary" (click)="onSubmit()">Weiter</button>
    </form>
  </div>
</app-tenant-config-proxy>
